import { IContractFormikStatus } from 'services/templates/types';

export const contractTemplateFormInitialStatus: IContractFormikStatus = {
  namePrefix: 'items',
  indentationWidth: 30,
  maxDepth: 3,
  minDepth: 1,
  indicator: true,
  hideContract: false,
};
